<template>
  <div>
    <uni-popup ref="check" type="bottom">
      <uni-card title="项目" :is-full="true" :note="true">
        <div class="drug_wrap">
          <div class="drug_msg">
            <div class="row_wrap fst_wrap">
              <span class="drug_name">{{ drugMsg.itemName }}</span>
              <span class="price">¥ {{ drugMsg.price }}</span>
            </div>
          </div>
          <div class="input_wrap">
            <span class="input_title">数量：</span>
            <div class="input_row">
              <input
                v-model="form.amount"
                type="number"
                placeholder="请输入"
                placeholder-style="color:#CECECE;font-size:.597333rem"
                placeholder-class="input-placeholder"
                class="input_con"
              />
            </div>
          </div>
          <uni-list-item title="单位：" :right-text="drugMsg.itemUnix" />
          <uni-list-item
            title="执行科室："
            :right-text="form.exeDeptName"
            :show-arrow="true"
            :clickable="true"
            @click="showExeDeptName"
          />
          <ms-select-dicNew
            v-if="checkType !== '2'"
            :code="'body_parts'"
            :visible="visible"
            :title="'部位：'"
            :right-text="form.bodyPart"
            :initRighttext="initRighttext"
            :uniListTop="true"
            @changeDicValue="changeBodyPart"
          ></ms-select-dicNew>
          <ms-select-dicNew
            v-if="checkType === '2'"
            :code="'sample_type'"
            :visible="visible"
            :title="'样本类型：'"
            :initRighttext="initRighttext"
            :right-text="form.sampleType"
            :uniListTop="true"
            @changeDicValue="changeSampleType"
          ></ms-select-dicNew>
          <div class="content">
            <div class="uni-textarea">
              <span class="input_title">说明：</span>
              <textarea
                v-model="form.detailDesc"
                placeholder="请输入"
                placeholder-style="color:#CECECE;font-size:.64rem"
                placeholder-class="textarea-placeholder"
                :show-confirm-bar="false"
              ></textarea>
            </div>
          </div>
        </div>
        <template v-slot:footer>
          <div class="footer-box" @click="confirmAddDrug">
            <span class="btn">确认</span>
          </div>
        </template>
        <template v-slot:close>
          <uni-icons type="closeempty" color="#666" @click="close" />
        </template>
      </uni-card>
    </uni-popup>
    <ms-select-exeDept ref="exeDeptName" :exeDeptList="exeDeptList" @change="setExeDeptName" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getKeyValueText } from '@/views/funcPuzzle/utils/util.js'
import MsSelectExeDept from '@/views/funcPuzzle/components/ms-select-exeDept/ms-select-exeDept.vue'
import MsSelectDicNew from '@/views/funcPuzzle/components/ms-select-dicNew/ms-select-dicNew.vue'

export default {
  components: {
    'ms-select-exeDept': MsSelectExeDept,
    'ms-select-dicNew': MsSelectDicNew
  },
  props: {
    modelValue: {
      type: [Boolean, String],
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    drugMsg: {
      type: [Object, String],
      default: ''
    },
    checkType: {
      type: [String],
      default: ''
    }
  },
  data() {
    return {
      showBody: false,
      showSample: false,
      initRighttext: true,
      searchValue: '',
      drugList: [],
      showDrugMsg: false,
      drugDesc: '1',
      form: {
        amount: '',
        itemUnix: '',
        exeDeptID: '',
        exeDeptName: '',
        bodyPart: '',
        detailDesc: '',
        sampleType: ''
      },
      mapRule: ''
    }
  },
  computed: {
    ...mapState('user', ['userInfos']),
    hospitalID() {
      return this.userInfos.hospitalID
    },
    doctor() {
      return this.$store.state.doctor
    },
    exeDeptList() {
      // console.log('this.doctor', this.doctor)
      // 申请单为治疗，如果没有执行科室，把医生的执行科室加进去
      if (this.drugMsg.exeDept) {
        let list = JSON.parse(this.drugMsg.exeDept) || []
        if (this.checkType === '4') {
          list.unshift({
            deptCode: this.doctor.deptID,
            deptName: this.doctor.deptName
          })

          list = list.filter(val => {
            return val.deptCode && val.deptName
          })
        }
        return list
      } else {
        return []
      }
    }
  },
  created() {
    // 国际蒙医部位是非必填项
    this.initRighttext = !['26373'].includes(this.hospitalID)
  },
  methods: {
    getKeyValueText,
    changeBodyPart(val) {
      // console.log('changeBodyPart', val)
      this.form.bodyPart = val
      // console.log('this.form', this.form)
    },
    changeSampleType(val) {
      this.form.sampleType = val
    },
    showExeDeptName() {
      this.$refs.exeDeptName.open()
    },
    setExeDeptName({ val, val2 }) {
      this.form.exeDeptID = val
      this.form.exeDeptName = val2
    },
    showSampleType() {
      this.$refs.sampleType.open()
    },
    setSampleType(val) {
      this.form.sampleType = val
    },
    startSampleType(val) {
      this.form.sampleType = val
    },
    showBodyPart() {
      this.$refs.bodyPart.open()
    },
    close() {
      if (!this.$refs.check) {
        return false
      }
      this.$emit('update:visible', false)

      this.$refs.check.close()

      this.$bus.emit('cancelAddCheck', true)
    },
    switchChange(e) {
      this.form.isDrugInducer = e.value ? '1' : '0'
    },
    confirmAddDrug() {
      // console.log('this.form', this.form)
      if (!this.form.amount) {
        uni.showToast({
          title: '请填写数量',
          icon: 'none'
        })
        return false
      }
      const noRequireBodyPartHos = ['26373'].includes(this.hospitalID)
      if (this.checkType != '2' && !this.form.bodyPart && !noRequireBodyPartHos) {
        uni.showToast({
          title: '请填写部位',
          icon: 'none'
        })
        return false
      }
      // 国际蒙医样本类型非必填默认是空
      if (!noRequireBodyPartHos) {
        this.form.sampleType = this.form.sampleType || '99'
      }

      this.form = Object.assign(this.drugMsg, this.form)

      this.$bus.emit('checkItem', this.form)
      this.$emit('update:visible', false)

      this.$refs.check.close()
      this.$emit('input', false)
    },
    open() {
      this.$emit('update:visible', true)
      this.$refs.check.open()
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.$refs.check.open()
        this.form = {
          amount: '1',
          itemUnix: '',
          exeDeptID: this.exeDeptList[0].deptCode,
          exeDeptName: this.exeDeptList[0].deptName,
          bodyPart: '',
          detailDesc: '',
          sampleType: ''
        }
        // console.log(this.form, 'this.form')
      } else {
        this.close()
      }
    },
    drugMsg(val) {
      this.form = {
        amount: '1',
        itemUnix: this.drugMsg.itemUnix,
        exeDeptID: this.exeDeptList[0].deptCode,
        exeDeptName: this.exeDeptList[0].deptName,
        bodyPart: '',
        detailDesc: '',
        sampleType: this.drugMsg.sampleType
      }
    }
  },
  mounted() {},
  unmounted() {
    this.$bus.off('checkItem')
    this.$bus.off('cancelAddCheck')
  }
}
</script>

<style lang="scss" scoped>
.uni-textarea {
  display: flex;
  flex-direction: column;
  // border-bottom: .021333rem solid #ececec;
  border-top: 0.021333rem solid #ececec;
  padding: 0.682667rem;
  .input_title {
    min-width: 2.986667rem;
    font-size: 0.597333rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #222222;
    line-height: 0.853333rem;
    margin-bottom: 0.298667rem;
  }
  .input_row {
    width: 2.133333rem;
  }
  .unit {
    margin-top: 0.085333rem;
  }
  .row_wrap {
    display: flex !important;
  }
}
.drug_wrap {
  height: 19.2rem;
  overflow-y: scroll;
  overflow-x: hidden;
  .input_wrap {
    display: flex;
    padding: 0.682667rem;
    align-items: center;
    justify-content: space-between;
    height: 0.810667rem;
    .input_row {
      display: flex;
      width: 3.626667rem;
      height: 100%;
      align-items: center;
      .input_con {
        text-align: right;
      }
      .unit {
        margin-left: 0.213333rem;
      }
    }
  }

  .drug_msg {
    display: flex;
    flex-direction: column;
    min-height: 0.810667rem;
    padding: 0.554667rem 0.682667rem;
    border-bottom: 0.021333rem solid #ececec;
    justify-content: center;
    text:first-child,
    text:nth-child(2) {
      margin-bottom: 0.256rem;
    }
    .drug_name {
      font-size: 0.597333rem;
      font-weight: 400;
      color: #222222;
      line-height: 0.853333rem;
      max-width: 12.373333rem;
    }
    .specification,
    .manufacturer {
      font-size: 0.512rem;
      font-weight: 400;
      color: #888888;
      line-height: 0.704rem;
    }
    .price {
      font-size: 0.64rem;
      font-weight: 400;
      color: #ff7555;
    }
    .row_wrap {
      display: flex;
      justify-content: space-between;
      .add {
        width: 2.133333rem;
        height: 0.981333rem;
        background: #0089ff;
        border-radius: 0.085333rem;
        text-align: center;
        line-height: 0.981333rem;
        color: #fff;
        font-size: 0.597333rem;
        font-weight: 400;
      }
    }
    .fst_wrap {
      display: flex;
      align-items: center;
    }
  }
}
.footer-box {
  text-align: center;
  width: 14.634667rem;
  height: 1.877333rem;
  background: #0089ff;
  border-radius: 0.938667rem;
  line-height: 1.877333rem;
  font-size: 0.682667rem;
  .btn {
    color: #fff;
  }
}
</style>
